<div class="gt-routes-list-containerss user-permissions">
  <dx-data-grid
    id="gridContainer"
    #userGrid
    [dataSource]="users"
    (onCellPrepared)="onCellPrepared($event)"
    class="gt-data-grid-style gt-margin-large-top gt-grid-left-top-corner-round"
    width="100%"
    (onRowUpdated)="saveUser($event)"
    (onRowInserted)="saveUser($event)"
    [editing]="{
      mode: 'form',
      texts: { saveRowChanges: 'CONFIRM', cancelRowChanges: 'CANCEL' }
    }"
    [allowColumnResizing]="true"
    [columnResizingMode]="'widget'"
    [columnAutoWidth]="false"
    [showBorders]="true"
    [scrolling]="{ mode: 'standard', useNative: true }"
    [width]="'100%'"
    [rowAlternationEnabled]="true"
    [hoverStateEnabled]="true"
  >
    <dxo-search-panel
      [visible]="true"
      [highlightCaseSensitive]="false"
      class="gt-search-panel search-float-off-toolbar"
      width="17vw"
      i18n-placeholder="@@search..."
      placeholder="Search..."
    ></dxo-search-panel>
    <dxo-toolbar>
      <dxi-item width="50%" name="searchPanel" location="before"></dxi-item>
      <dxi-item width="50%">
        <div class="gt-flex-dir-row">
          <app-gpd-button
            class="gpd-button"
            i18n-text="@@add"
            icon="add"
            (onClick)="addNewRow($event)"
            text="Add"
            >
            </app-gpd-button>
            <!--                 <app-gpd-button
            icon="tick"
            i18n-text="@@save"
            text="Save"
            (onClick)="saveChanges($event)"
          ></app-gpd-button> -->
        </div>
      </dxi-item>
    </dxo-toolbar>

    <dxi-column
      dataField="firstName"
      i18n-caption="@@firstname"
      caption="Firstname"
      addSelectBoxVisible
    >
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>
    <dxi-column
      dataField="lastName"
      i18n-caption="@@lastname"
      caption="Lastname"
    >
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>
    <dxi-column
      dataField="emailAddress"
      i18n-caption="@@email"
      caption="Email"
      [allowEditing]="false"
    >
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>
    <dxi-column
      editCellTemplate="editRolesTemplate"
      dataField="userRole"
      i18n-caption="@@role"
      caption="Role"
    >
      <dxo-lookup
        [dataSource]="roles"
        displayExpr="name"
        valueExpr="id"
      ></dxo-lookup>
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <div *dxTemplate="let item of 'editRolesTemplate'">
      <dx-select-box
        [dataSource]="roles"
        displayExpr="name"
        valueExpr="id"
        [(value)]="item.data.userRole"
        (onValueChanged)="item.setValue($event.value)"
      >
      </dx-select-box>
    </div>

    <dxi-column
      dataField="reportsToEmail"
      i18n-caption="@@reportsTo"
      caption="reports to"
    >
      <dxo-lookup
        [dataSource]="listOfUsers"
        displayExpr="displayName"
        valueExpr="emailAddress"
      ></dxo-lookup>
    </dxi-column>

    <dxi-column
      dataField="departmentId"
      i18n-caption="@@department"
      caption="Department"
    >
      <dxo-lookup
        [dataSource]="departments"
        displayExpr="name"
        valueExpr="id"
        [allowClearing]="true"
      ></dxo-lookup>
    </dxi-column>

    <dxi-column
      dataField="userRightsId"
      i18n-caption="@@userRights"
      caption="User Rights"
      [visible]="false"
      [editorOptions]="{
        displayExpr: 'text',
        dataSource: userRightsList,
        valueExpr: 'id'
      }"
      editCellTemplate="userPermissionsTempalte"
    >
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <div *dxTemplate="let item of 'userPermissionsTempalte'">
        <dx-select-box
          [(value)]="item.value"
          [dataSource]="userRightsList"
          displayExpr="text"
          valueExpr="id"
          (onValueChanged)="changeUserPermissions($event, item)"
        >
        </dx-select-box>

        <dx-check-box
          [(value)]="item.data.canView"
          i18n-text="@@canViewUserPermission"
          text="Can View"
          class="gt-margin-small-left gt-margin-small-right"
          [disabled]="true"
        ></dx-check-box>
        <dx-check-box
          [(value)]="item.data.canEdit"
          i18n-text="@@canEditUserPermission"
          text="Can Edit"
          class="gt-margin-small-left gt-margin-small-right"
          [disabled]="true"
        ></dx-check-box>
        <dx-check-box
          [(value)]="item.data.canComplete"
          i18n-text="@@completeTaskUserPermission"
          text="Complete Task"
          class="gt-margin-small-left gt-margin-small-right"
          [disabled]="true"
        ></dx-check-box>
        <dx-check-box
          [(value)]="item.data.canValidate"
          i18n-text="@@validateTaskUserPermission"
          text="Validate Task"
          class="gt-margin-small-left gt-margin-small-right"
          [disabled]="true"
        ></dx-check-box>
        <dx-check-box
          [(value)]="item.data.canDelete"
          i18n-text="@@canDeleteUserPermission"
          text="Can Delete"
          class="gt-margin-small-left gt-margin-small-right"
          [disabled]="true"
        ></dx-check-box>
      </div>
    </dxi-column>

    <dxi-column
      dataField
      caption
      [editorOptions]="{ readOnly: true }"
      editCellTemplate="editCanViewTemplate"
      cellTemplate="canViewTemplate"
      headerCellTemplate="canViewHeaderTemplate"
    >
    </dxi-column>
    <div *dxTemplate="let item of 'editCanViewTemplate'"></div>
    <div *dxTemplate="let item of 'canViewTemplate'" class="justify-check-box">
      <dx-check-box
        [(value)]="item.data.canView"
        [disabled]="true"
      ></dx-check-box>
    </div>
    <div
      *dxTemplate="let info of 'canViewHeaderTemplate'"
      i18n="@@canViewUserPermission"
    >
      Can View
    </div>

    <dxi-column
      dataField
      caption
      [editorOptions]="{ readOnly: true }"
      editCellTemplate="editCanEditTemplate"
      cellTemplate="canEditTemplate"
      headerCellTemplate="canEditHeaderTemplate"
    >
    </dxi-column>
    <div *dxTemplate="let item of 'editCanEditTemplate'"></div>
    <div *dxTemplate="let item of 'canEditTemplate'" class="justify-check-box">
      <dx-check-box [(value)]="item.data.canEdit" [disabled]="true">
      </dx-check-box>
    </div>
    <div
      *dxTemplate="let info of 'canEditHeaderTemplate'"
      i18n="@@canEditUserPermission"
    >
      Can Edit
    </div>

    <dxi-column
      dataField
      caption
      [editorOptions]="{ readOnly: true }"
      editCellTemplate="editCanCompleteTemplate"
      cellTemplate="canCompleteTemplate"
      headerCellTemplate="canCompleteHeaderTemplate"
    >
    </dxi-column>
    <div *dxTemplate="let item of 'editCanCompleteTemplate'"></div>
    <div
      *dxTemplate="let item of 'canCompleteTemplate'"
      class="justify-check-box"
    >
      <dx-check-box
        [(value)]="item.data.canComplete"
        [disabled]="true"
      ></dx-check-box>
    </div>
    <div
      *dxTemplate="let info of 'canCompleteHeaderTemplate'"
      i18n="@@completeTaskUserPermission"
    >
      Can Complete
    </div>

    <dxi-column
      dataField
      caption
      [editorOptions]="{ readOnly: true }"
      editCellTemplate="editCanValidateTemplate"
      cellTemplate="canValidateTemplate"
      headerCellTemplate="canValidateHeaderTemplate"
    >
    </dxi-column>
    <div *dxTemplate="let item of 'editCanValidateTemplate'"></div>
    <div
      *dxTemplate="let item of 'canValidateTemplate'"
      class="justify-check-box"
    >
      <dx-check-box
        [(value)]="item.data.canValidate"
        [disabled]="true"
      ></dx-check-box>
    </div>
    <div
      *dxTemplate="let info of 'canValidateHeaderTemplate'"
      i18n="@@validateTaskUserPermission"
    >
      Can Validate
    </div>

    <dxi-column
      dataField
      caption
      [editorOptions]="{ readOnly: true }"
      editCellTemplate="editCanDeleteTemplate"
      cellTemplate="canDeleteTemplate"
      headerCellTemplate="canDeleteHeaderTemplate"
    >
    </dxi-column>
    <div *dxTemplate="let item of 'editCanDeleteTemplate'"></div>
    <div
      *dxTemplate="let item of 'canDeleteTemplate'"
      class="justify-check-box"
    >
      <dx-check-box
        [(value)]="item.data.canDelete"
        [disabled]="true"
      ></dx-check-box>
    </div>
    <div
      *dxTemplate="let info of 'canDeleteHeaderTemplate'"
      i18n="@@canDeleteUserPermission"
    >
      Can Delete
    </div>

    <dxi-column
      caption
      cellTemplate="deleteCellTemplate"
      [allowEditing]="false"
      editCellTemplate="editButtonsTemplate"
    >
    </dxi-column>
    <div *dxTemplate="let item of 'deleteCellTemplate'" class="gpd-table-actions">
      <app-svg-icon icon="edit" color="var(--color-primary)" [size]="20" [strokeWidth]="1.5" i18n-title="@@edit" title="Edit" (click)="initEditUser($event, item)"></app-svg-icon>
      <app-svg-icon icon="delete" color="var(--color-red-500)" [size]="20" [strokeWidth]="1.5" i18n-title="@@delete" title="Delete" (click)="confirmDelete($event, item.data)"></app-svg-icon>
    </div>

    <div *dxTemplate="let item of 'editButtonsTemplate'"></div>
  </dx-data-grid>
</div>

<app-generic-popup
  [(visible)]="showProjectList"
  [title]="deleteUserPopupTitle"
  [titleIcon]="isGridVisible || hasDeadlines || hasOwnedContracts || hasSharedTables || hasRules ? 'alert' : undefined"
  [width]="popupWidth"
  [height]="popupHeight"
  [maxHeight]="popupMaxHeight"
  [buttons]="projectDeleteButtons"
>
  <div class="confirmation-message" [innerHTML]="confirmationMessage"></div>
  <div *ngIf="isGridVisible" class="affected-list-card">
    <dx-data-grid
      [dataSource]="affectedProjectsList"
      [allowColumnResizing]="true"
      [columnResizingMode]="'widget'"
      [columnAutoWidth]="true"
      [showBorders]="false"
      [showRowLines]="true"
      [scrolling]="{ mode: 'standard', useNative: true }"
      [hoverStateEnabled]="false"
      [selection]="{ mode: 'none' }"
      [keyboardNavigation]="{ enabled: false }"
    >
      <dxi-column
        dataField="projectName1"
        i18n-caption="@@projectName"
        caption="Project Name"
      ></dxi-column>
      <dxi-column
        dataField="projectName2"
        i18n-caption="@@projectName"
        caption="Project Name"
      ></dxi-column>
    </dx-data-grid>
  </div>

  <div *ngIf="hasDeadlines" class="affected-list-card">
    <dx-data-grid
      [dataSource]="affectedDeadlinesList"
      [showBorders]="false"
      [showRowLines]="true"
      [columnAutoWidth]="true"
      [hoverStateEnabled]="false"
      [selection]="{ mode: 'none' }"
      [keyboardNavigation]="{ enabled: false }"
    >
      <dxi-column dataField="designation" i18n-caption="@@contract" caption="Contract"></dxi-column>
      <dxi-column dataField="deadlineTypeName" i18n-caption="@@deadlineType" caption="Deadline Type"></dxi-column>
      <dxi-column dataField="date" dataType="date" i18n-caption="@@date" caption="Date"></dxi-column>
    </dx-data-grid>
  </div>

  <!-- #1949: contracts the user owns. A restricted one is invisible even to administrators,
       so its ownership can only be handed on here. -->
  <div *ngIf="hasOwnedContracts" class="affected-list-card">
    <dx-data-grid
      [dataSource]="ownedContractsList"
      [showBorders]="false"
      [showRowLines]="true"
      [columnAutoWidth]="true"
      [hoverStateEnabled]="false"
      [selection]="{ mode: 'none' }"
      [keyboardNavigation]="{ enabled: false }"
    >
      <dxi-column dataField="designation" i18n-caption="@@contract" caption="Contract"></dxi-column>
      <dxi-column
        dataField="isRestricted"
        i18n-caption="@@contractAccess"
        caption="Access"
        cellTemplate="restrictedCellTemplate"
      >
        <div *dxTemplate="let item of 'restrictedCellTemplate'">
          <span *ngIf="item.data.isRestricted" i18n="@@restricted">Restricted</span>
          <span *ngIf="!item.data.isRestricted" i18n="@@visibleToEveryone">Visible to everyone</span>
        </div>
      </dxi-column>
    </dx-data-grid>
  </div>

  <!-- #1016: dynamic tables other users work with; the project successor takes them over -->
  <div *ngIf="hasSharedTables" class="affected-list-card">
    <dx-data-grid
      [dataSource]="sharedTablesList"
      [showBorders]="false"
      [showRowLines]="true"
      [columnAutoWidth]="true"
      [hoverStateEnabled]="false"
      [selection]="{ mode: 'none' }"
      [keyboardNavigation]="{ enabled: false }"
    >
      <dxi-column dataField="title" i18n-caption="@@sharedTable" caption="Shared table"></dxi-column>
    </dx-data-grid>
  </div>

  <!-- #4938: task rules that name the user as fixed recipient or assignee -->
  <div *ngIf="hasRules" class="affected-list-card">
    <dx-data-grid
      [dataSource]="affectedRulesList"
      [showBorders]="false"
      [showRowLines]="true"
      [columnAutoWidth]="true"
      [hoverStateEnabled]="false"
      [selection]="{ mode: 'none' }"
      [keyboardNavigation]="{ enabled: false }"
    >
      <dxi-column dataField="ruleName" i18n-caption="@@rule" caption="Rule"></dxi-column>
      <dxi-column dataField="taskTitle" i18n-caption="@@task" caption="Task"></dxi-column>
    </dx-data-grid>
  </div>

  <div *ngIf="isGridVisible || hasSharedTables" class="successor-field">
    <span *ngIf="isGridVisible && !hasSharedTables" i18n="@@projectSuccessor">Who takes over the projects?</span>
    <span *ngIf="isGridVisible && hasSharedTables" i18n="@@projectAndTableSuccessor">Who takes over the projects and shared tables?</span>
    <span *ngIf="!isGridVisible" i18n="@@tableSuccessor">Who takes over the shared tables?</span>
    <dx-select-box
      [dataSource]="successorOptions"
      displayExpr="displayName"
      valueExpr="emailAddress"
      [(value)]="projectSuccessor"
      [searchEnabled]="true"
      i18n-placeholder="@@selectSuccessor"
      placeholder="Select a successor"
    ></dx-select-box>
  </div>

  <div *ngIf="hasDeadlines" class="successor-field">
    <span i18n="@@deadlineSuccessor">Who takes over the contract deadlines?</span>
    <dx-select-box
      [dataSource]="successorOptions"
      displayExpr="displayName"
      valueExpr="emailAddress"
      [(value)]="deadlineSuccessor"
      [searchEnabled]="true"
      i18n-placeholder="@@selectSuccessor"
      placeholder="Select a successor"
    ></dx-select-box>
  </div>

  <div *ngIf="hasOwnedContracts" class="successor-field">
    <span i18n="@@contractSuccessor">Who manages access to these contracts from now on?</span>
    <dx-select-box
      [dataSource]="successorOptions"
      displayExpr="displayName"
      valueExpr="emailAddress"
      [(value)]="contractSuccessor"
      [searchEnabled]="true"
      i18n-placeholder="@@selectSuccessor"
      placeholder="Select a successor"
    ></dx-select-box>
  </div>

  <div *ngIf="hasRules" class="successor-field">
    <span i18n="@@ruleSuccessor">Who takes their place in these rules?</span>
    <dx-select-box
      [dataSource]="successorOptions"
      displayExpr="displayName"
      valueExpr="emailAddress"
      [(value)]="ruleSuccessor"
      [searchEnabled]="true"
      i18n-placeholder="@@selectSuccessor"
      placeholder="Select a successor"
    ></dx-select-box>
  </div>
</app-generic-popup>

<dx-popup
  dragEnabled="true"
  resizeEnabled="true"
  [visible]="popupVisible"
  (onHiding)="popupVisible = false"
  width="800"
  height="90vh"
  (onShowing)="initializeAddingRow($event)"
  i18n-title="@@addUserPermissions"
  title="Add User Permissions"
>
  <form (submit)="saveNewUser($event)">
    <div class="dx-fieldset">
      <div class="dx-field">
        <div class="dx-field">
          <div i18n="@@firstname" class="dx-field-label required">
            Firstname
          </div>
          <div class="dx-field-value">
            <dx-text-box [(value)]="newUser.firstName">
              <dx-validator>
                <dxi-validation-rule
                  type="required"
                  i18n-message="@@firstNameIsRequired"
                  message="First Name is required"
                ></dxi-validation-rule> </dx-validator
            ></dx-text-box>
          </div>
        </div>
        <div class="dx-field">
          <div i18n="@@lastname" class="dx-field-label required">Lastname</div>
          <div class="dx-field-value">
            <dx-text-box [(value)]="newUser.lastName">
              <dx-validator>
                <dxi-validation-rule
                  type="required"
                  i18n-message="@@lastNameIsRequired"
                  message="Last Name is required"
                ></dxi-validation-rule> </dx-validator
            ></dx-text-box>
          </div>
        </div>
        <div class="dx-field" style="margin-top: 10px">
          <div i18n="@@emailAddress" class="dx-field-label required">
            Email Address
          </div>
          <div class="dx-field-value">
            <dx-text-box [(value)]="newUser.emailAddress">
              <dx-validator>
                <dxi-validation-rule
                  type="required"
                  i18n-message="@@emailIsRequired"
                  message="Email Address is required"
                ></dxi-validation-rule> </dx-validator
            ></dx-text-box>
          </div>
        </div>
        <div class="dx-field">
          <div i18n="@@reportsTo" class="dx-field-label">Reports To</div>
          <div class="dx-field-value">
            <dx-select-box
              [(value)]="newUser.reportsToEmail"
              [dataSource]="listOfUsers"
              displayExpr="displayName"
              valueExpr="emailAddress"
            >
            </dx-select-box>
          </div>
        </div>
        <div class="dx-field">
          <div i18n="@@department" class="dx-field-label">Department</div>
          <div class="dx-field-value">
            <dx-select-box
              [(value)]="newUser.departmentId"
              [dataSource]="departments"
              displayExpr="name"
              valueExpr="id"
              [showClearButton]="true"
            >
            </dx-select-box>
          </div>
        </div>
        <div i18n="@@role" class="dx-field-label required">Role</div>
        <div class="dx-field-value">
          <dx-select-box
            [dataSource]="roles"
            valueExpr="id"
            displayExpr="name"
            [(value)]="newUser.role"
          >
            <dx-validator>
              <dxi-validation-rule
                type="required"
                i18n-message="@@roleIsRequired"
                message="Role is required"
              ></dxi-validation-rule>
            </dx-validator>
          </dx-select-box>
        </div>
      </div>

      <div class="dx-field">
        <div i18n="@@userRights" class="dx-field-label required">
          User Rights
        </div>

        <div class="dx-field-value">
          <dx-select-box
            [(value)]="newUser.userRightsId"
            [dataSource]="userRightsList"
            displayExpr="text"
            valueExpr="id"
            (onValueChanged)="changeNewUserPermissions($event, newUser)"
          >
            <dx-validator>
              <dxi-validation-rule
                type="required"
                i18n-message="@@userRightsIsRequired"
                message="User Rights is required"
              ></dxi-validation-rule>
            </dx-validator>
          </dx-select-box>
        </div>
      </div>

      <div class="gt-flex-dir-row" style="justify-content: space-between">
        <div class="gt-flex-dir-row" style="justify-content: space-between">
          <div i18n="@@canViewUserPermission" style="margin-right: 15px">
            Can View
          </div>
          <dx-check-box
            [value]="newUser.canView"
            [disabled]="true"
          ></dx-check-box>
        </div>
        <div class="gt-flex-dir-row" style="justify-content: space-between">
          <div i18n="@@canEditUserPermission" style="margin-right: 15px">
            Can Edit
          </div>
          <dx-check-box
            [value]="newUser.canEdit"
            [disabled]="true"
          ></dx-check-box>
        </div>
        <div class="gt-flex-dir-row" style="justify-content: space-between">
          <div i18n="@@completeTaskUserPermission" style="margin-right: 15px">
            Complete Task
          </div>
          <dx-check-box
            [value]="newUser.canComplete"
            [disabled]="true"
          ></dx-check-box>
        </div>
        <div class="gt-flex-dir-row" style="justify-content: space-between">
          <div i18n="@@validateTaskUserPermission" style="margin-right: 15px">
            Validate Task
          </div>
          <dx-check-box
            [value]="newUser.canValidate"
            [disabled]="true"
          ></dx-check-box>
        </div>
        <div class="gt-flex-dir-row" style="justify-content: space-between">
          <div i18n="@@canDeleteUserPermission" style="margin-right: 15px">
            Can Delete
          </div>
          <dx-check-box
            [value]="newUser.canDelete"
            [disabled]="true"
          ></dx-check-box>
        </div>
      </div>
    </div>

    <div class="gt-bottom-page-button-container">
      <div class="gt-flex-width">
        <app-gpd-button
          type="secondary"
          i18n-text="@@cancel"
          text="Cancel"
          (onClick)="abortSelection($event)"
        ></app-gpd-button>
      </div>
      <div class="gt-flex-dir-row-rev">
        <app-gpd-button
          icon="tick"
          i18n-text="@@save"
          text="Save"
          [useSubmitBehavior]="true"
          [disabled]="savingNewUser"
        ></app-gpd-button>
      </div>
    </div>
  </form>
</dx-popup>

<app-delete-popup
  [visible]="deletePopupVisible"
  [message]="message"
  (onAbort)="onAbort($event)"
  (onConfirm)="onConfirm($event)"
></app-delete-popup>

<dx-toast
  [visible]="toastVisible"
  [type]="type"
  message="{{ message }}"
  position="bottom center"
  width="fit-content"
>
</dx-toast>
